// import the sassy styles ***********************
import "./site.scss";


// quick and dirty way to make HMR work(ish)
if (module.hot) {
  module.hot.accept();
}


// plugin scripts *****************************
require('script-loader!./js/total-modal.js');
require('script-loader!../node_modules/magnific-popup/dist/jquery.magnific-popup.js');
// require('script-loader!./js/single-page-nav.js');


// custom scripts *****************************
// NOTE: enable script below if you have a DROP DOWN MAIN MENU -> then update classes in script for your site
// require('./js/touch-navigation');
require('./js/scripts');
